import React from "react";
import Heading from "../common/heading/Heading";
import "./about.css";
import Awrapper from "./Awrapper";

const AboutCard2 = () => {
  return (
    <>
      <section className="aboutHome">
        <div className="container flexSB">

          <div className="left row">
                      <br/>         
          <br/>
          <br/>         
          <br/>
          <br/>         
          <br/>

            <div className="video-container">
              <iframe
                width="100%"
                height="350"
                src="https://www.youtube.com/embed/AM5ZjoUhzEw?si=xSumt_AGq9DSC1N2"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>

          {/* ✅ النصوص والمحتوى */}
          <div className="right row">
            <Heading
              subtitle="انطلق في رحلة نحو التفوق في امتحانات الثانوية العامة مع دروس تفاعلية ومراجعات مركزة."
              title="مميزات التعلم مع م/إسلام عبدالعظيم"
            />

          <div className="items">
  <div className="item flexSB">
    <div className="icon">⚗️</div>
    <div className="text">
      <h2>شرح مفاهيم الكيمياء ببساطة</h2>
      <p>عرض دقيق وسهل للمفاهيم الكيميائية بطريقة واضحة تساعدك على الفهم بدون تعقيد.</p>
    </div>
  </div>

  <div className="item flexSB">
    <div className="icon">🧪</div>
    <div className="text">
      <h2>تجارب وتمثيلات تفاعلية</h2>
      <p>شرح التجارب الكيميائية مع رسومات وأمثلة عملية لتثبيت المعلومة.</p>
    </div>
  </div>

  <div className="item flexSB">
    <div className="icon">📘</div>
    <div className="text">
      <h2>اختبارات وملخصات شاملة</h2>
      <p>نماذج امتحانات وملخصات مركّزة لمساعدتك على الاستعداد لـ الثانوية العامة.</p>
    </div>
  </div>
</div>
</div>

        </div>
      </section>
    </>
  );
};

export default AboutCard2;
